import { ScrollPanel } from 'primereact/scrollpanel'
import { useEffect } from 'react'
import MessageBox from '../MessageBox'
import styles from './styles.module.css'
import { InterviewConversation } from '../../../../../../AdminPortal/scenes/Interview/interface'

interface MessageListProps {
  conversations: InterviewConversation[]
  interviewerName: string
  handleRetrieveRecording: (index: number) => void
}

const MessageList = (props: MessageListProps) => {
  const { conversations, interviewerName } = props

  //Logic to auto scroll to latest message
  useEffect(() => {
    const scrollPanel = document.querySelector(".p-scrollpanel-content")
    if (scrollPanel) {
      scrollPanel.scrollTo({ top: scrollPanel.scrollHeight, behavior: 'smooth' })
    }
  }, [conversations])

  return (
    <div className={styles.chatbot}>
      <ScrollPanel id="scrollPanel" style={{ width: '100%', height: '60vh'}}>
        <div style={{ padding: '1em', lineHeight: '1.5' }}>
          {conversations.filter(item => item.index > 1).map((item, index) => {
            //Temporary unique key
            return <MessageBox 
              key={index.toString()} 
              role={item.role} 
              interviewerName={interviewerName}
              message={item.message} 
              index={item.index} 
              questionNumber={item.questionNumber}
              handleRetrieveRecording={props.handleRetrieveRecording}/>
          })}
        </div>
      </ScrollPanel>
    </div>
  )
}

export default MessageList